import { render } from "./CategoryCards.vue?vue&type=template&id=39bdfa2c&scoped=true"
import script from "./CategoryCards.vue?vue&type=script&lang=js"
export * from "./CategoryCards.vue?vue&type=script&lang=js"

import "./CategoryCards.vue?vue&type=style&index=0&id=39bdfa2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bdfa2c"]])

export default __exports__